import { BaseStorage } from './base-storage';

export const SessionStorage = new BaseStorage(globalThis.sessionStorage);
